import { JSONLikeObject } from "@cede/types";

export const mapToObject = <K extends string, V extends JSONLikeObject>(map: Map<K, V>) => {
  return Object.fromEntries(map.entries());
};
